/**
 * Generating a middleware enforcing a structure on an array of data
 */
import enforceGenrator from '../structures/enforce';

function getStruturedData(data, enforceStructure) {
  const result = {};

  Object.values(data)
    .forEach(item => {
      const structuredItem = enforceStructure(item);
      result[structuredItem.id] = enforceStructure(item);
    });

  return result;
}

export default structureSchema => {
  const structureEntries = Object.entries(structureSchema)
    .map(([type, structure]) => [type, enforceGenrator(structure)]);

  return () => next => action => {
    const data = action.data;

    if (!!data && !action.bypassMiddleware) {
      structureEntries
        .filter(arg => !!data[arg[0]])
        .forEach(([type, enforceStructure]) => {
          data[type] = getStruturedData(data[type], enforceStructure);
        });
    }

    return next(action);
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/middlewares/middlewareStructureGenerator.js